/**
 * feat-303-curriculum-drip-release — every on-screen string for the admin drip
 * controls, in ONE place (design/NOTES.md §5 IDs in the comments).
 *
 * Kept together on purpose: the turn-off confirms (T6, L7) depend on how
 * re-enabling drip treats grandfathering (DESIGN-QUESTION.md Q1), which may
 * still change. Edit the wording here, never at the call site.
 */

/** T1 — tenant checkbox label. */
export const DRIP_LABEL = 'Drip release';
/** T2 — rate suffix (tenant row and location modal). */
export const DRIP_RATE_SUFFIX = 'lessons per day';
/** T3 — helper paragraph; the lead-in is rendered bold. */
export const DRIP_HELP_LEAD = 'Drip release.';
export const DRIP_HELP_BODY =
  "Each learner gets lessons one at a time: the next one unlocks when they finish the current one, up to the daily rate. Days count from the later of the learner's consent and their location's go-live date. We use Square worked days when we have the learner's POS data and the location is live, and calendar days otherwise. Missed days carry over. Lessons marked “Skip drip” are always available, and anything a learner can already see stays visible when drip turns on.";
/** T4 */
export const DRIP_SAVING = 'Saving…';
/** T5 */
export const DRIP_RATE_INVALID = 'Enter a whole number from 1 to 20.';
/** T6 */
export const dripTenantTurnOffConfirm = (tenantName: string) =>
  `Turn off drip release for ${tenantName}? Learners at locations that follow the tenant setting will see every available lesson right away. If you turn drip back on later, they keep everything they could see.`;
/** T7 */
export const dripSaveFailed = (message?: string | null) =>
  message ? `Failed to update drip release: ${message}` : 'Failed to update drip release';

/** L1–L4 — location header summary: prefix + value (value is emphasised on an override). */
export const DRIP_SUMMARY_PREFIX = 'Drip release: ';
export const dripSummaryValue = (enabled: boolean, rate: number, overridden: boolean) =>
  `${enabled ? `On · ${rate}/day` : 'Off'} ${overridden ? '(override)' : '(inherited)'}`;

/** Legend of the Edit Location fieldset. */
export const DRIP_LOCATION_LEGEND = 'Drip release';
/** L5a/b/c */
export const DRIP_LOCATION_INHERIT = 'Same as tenant';
export const dripLocationInheritDetail = (enabled: boolean, rate: number) =>
  enabled ? ` (On · ${rate}/day)` : ' (Off)';
export const DRIP_LOCATION_ON = 'On for this location';
export const DRIP_LOCATION_OFF = 'Off for this location';
/** L6 — aria-label of the location rate input. */
export const DRIP_LOCATION_RATE_ARIA = 'Lessons per day for this location';
/** L7 */
export const dripLocationTurnOffConfirm = (locationName: string) =>
  `Turn off drip release for ${locationName}? Its learners will see every available lesson right away. If you turn drip back on later, they keep everything they could see.`;
/** L8 */
export const DRIP_LOCATION_HELP =
  'Applies to learners whose home location is this one, including staff who also work at other locations.';

/** S1–S4 — the per-Lesson bypass toggle on /quiz-management. */
export const SKIP_DRIP_LABEL = 'Skip drip';
export const SKIP_DRIP_TITLE_OFF = 'Release this Lesson through drip, one at a time per learner';
export const SKIP_DRIP_TITLE_ON =
  "Every learner gets this Lesson as soon as it's available. Drip doesn't hold it back or count it.";
export const SKIP_DRIP_SUBLINE =
  "Available to every learner right away. Drip doesn't hold it back or count it.";
